/* global globalThis */
import PropTypes from "prop-types";
import { Component } from "react";
import { Box, Button, Typography } from "@mui/material";

/**
 * Catches render errors and shows a lightweight fallback.
 */
class AppErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Surface the error for monitoring; console is a minimal default.
    // eslint-disable-next-line no-console
    console.error("Unhandled UI error:", error, info);
  }

  handleReload = () => {
    // Force a full reload to recover from irrecoverable UI state.
    globalThis.location.reload();
  };

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (!hasError) return children;

    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          gap: 2,
          p: 3,
        }}
      >
        <Typography variant="h5" fontWeight={700}>
          Something went wrong
        </Typography>
        <Typography color="text.secondary">
          The page failed to load. You can try reloading to continue.
        </Typography>
        <Button variant="contained" onClick={this.handleReload}>
          Reload
        </Button>
      </Box>
    );
  }
}

AppErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AppErrorBoundary;
